import { ConfigProvider } from 'antd';
import './App.css';
import RegistrationController from './pages/Registration';

function App() {
  const queryParams = new URLSearchParams(window.location.search);
  const platform = queryParams.get("platform") || "yeti";
  console.log(platform);

  let platformStyle = ""; // or let platformStyle = "";
  if (platform === 'yeti') {
    platformStyle = '#3FA9F5'; // or platformStyle = "yeti";
  } else if (platform === 'fixyourfunnel') {
    platformStyle = '#00b96b'; // or platformStyle = "fixyourfunnel";
  }
  return (
    <div className="App" >
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: platformStyle,
          },
        }}
      >
        <RegistrationController />
      </ConfigProvider>

    </div>
  );
}

export default App;
